import React from "react";
import { StatusBadgeProps } from "./StatusBadge.types";
import { StyledBadge } from "./StatusBadge.styles";

const normalizeStatusText = (text: string) => {
  if (text === "ДА") return "Да";
  if (text === "НЕТ") return "Нет";
  return text;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  text,
  variant = "green",
  appearance = "soft",
  asButton = false,
  onClick,
}) => {
  return (
    <StyledBadge
      variant={variant}
      appearance={appearance}
      asButton={asButton}
      onClick={asButton ? onClick : undefined}
    >
      {normalizeStatusText(text)}
    </StyledBadge>
  );
};

export default StatusBadge;